"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uuid = _interopRequireDefault(require("uuid"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = require("prop-types");

require("./CheckboxButton.scss");

var _Icon = _interopRequireDefault(require("../../Icon"));

var _excluded = ["name", "value", "buttonText", "onChange", "checked", "size", "skin", "iconLeft", "iconRight", "hideText", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var propTypes = {
  /** The text on the button */
  buttonText: _propTypes.string.isRequired,

  /** The name of the input */
  name: _propTypes.string,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: _propTypes.string,

  /** The value of the input */
  value: _propTypes.string,

  /** Make a radio input disabled*/
  disabled: _propTypes.bool,

  /** Place icon before text.*/
  iconLeft: _propTypes.element,

  /** Place icon after text. */
  iconRight: _propTypes.element,

  /** Hides the text visually. Still available for screen readers */
  hideText: _propTypes.bool,

  /** The value that should be marked as selected */
  checked: _propTypes.bool,

  /** Set the size of the input button */
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large']),

  /** Choose between these skins: */
  skin: (0, _propTypes.oneOf)(['dark', 'light']),

  /** Callback function for when the checkbox changes. */
  onChange: _propTypes.func,

  /** Add your own custom class names to the component */
  className: _propTypes.string
};
var defaultProps = {
  size: 'medium',
  skin: 'dark'
};
/** Behaves like a checkbox but has the appearance of a button.
 * @visibleName Checkbox Button
 * */

var CheckboxButton = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxButton, _Component);

  var _super = _createSuper(CheckboxButton);

  function CheckboxButton(props) {
    var _this;

    _classCallCheck(this, CheckboxButton);

    _this = _super.call(this, props);
    _this.id = props.id || "rds-checkbox-btn-".concat(_uuid.default.v4());
    return _this;
  }

  _createClass(CheckboxButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          name = _this$props.name,
          value = _this$props.value,
          buttonText = _this$props.buttonText,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          size = _this$props.size,
          skin = _this$props.skin,
          iconLeft = _this$props.iconLeft,
          iconRight = _this$props.iconRight,
          hideText = _this$props.hideText,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var iconSize = size;
      var componentClassNames = (0, _classnames.default)('rds-checkbox-btn', {
        'rds-checkbox-btn--small': size === 'small',
        'rds-checkbox-btn--medium': size === 'medium',
        'rds-checkbox-btn--large': size === 'large',
        'rds-checkbox-btn--light': skin === 'light',
        'rds-checkbox-btn--icon-only': !buttonText || buttonText === '' || hideText,
        'rds-checkbox-btn--has-icon-left': iconLeft,
        'rds-checkbox-btn--has-icon-right': iconRight
      }, className);
      var textClassNames = (0, _classnames.default)('rds-checkbox-btn__text', {
        'rds-is-vishidden': hideText
      });
      return /*#__PURE__*/_react.default.createElement("div", {
        className: componentClassNames
      }, /*#__PURE__*/_react.default.createElement("input", _extends({
        className: 'rds-checkbox-btn__input',
        type: "checkbox",
        checked: checked,
        name: name,
        id: this.id,
        value: value,
        onChange: onChange
      }, rest)), /*#__PURE__*/_react.default.createElement("label", {
        className: "rds-checkbox-btn__label",
        htmlFor: this.id
      }, iconLeft && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        component: iconLeft,
        size: iconSize,
        className: "rds-checkbox-btn__icn"
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: textClassNames
      }, buttonText), iconRight && /*#__PURE__*/_react.default.createElement(_Icon.default, {
        component: iconRight,
        size: iconSize,
        className: "rds-checkbox-btn__icn"
      })));
    }
  }]);

  return CheckboxButton;
}(_react.Component);

CheckboxButton.propTypes = propTypes;
CheckboxButton.defaultProps = defaultProps;
var _default = CheckboxButton;
exports.default = _default;